import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Message } from '~src/components/helpers/forms';
import ActionButton from '~src/components/molecules/ActionButton';
import { useReturnToAccountMutation } from '~src/graphql/mutations/clients';
import { useAppDispatch } from '~src/redux/hooks';
import { setSession } from '~src/redux/slices/sessionSlice';

function TestButton() {
  const dispatch = useAppDispatch();
  const [returnToAccount, { data }] = useReturnToAccountMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      dispatch(setSession({
        email: data.ReturnToAccount.UserFirmAccount.Users.email,
        accessToken: data.ReturnToAccount.accessToken,
        id: data.ReturnToAccount.UserFirmAccount.Users.UserInformation.id,
        userId: data.ReturnToAccount.UserFirmAccount.Users.id,
        userInformationId: data.ReturnToAccount.UserFirmAccount.Users.UserInformation.id,
        firstName: data.ReturnToAccount.UserFirmAccount.Users.UserInformation.firstName,
        lastName: data.ReturnToAccount.UserFirmAccount.Users.UserInformation.lastName,
        birthday: data.ReturnToAccount.UserFirmAccount.Users.UserInformation.birthday,
        ssn: data.ReturnToAccount.UserFirmAccount.Users.UserInformation.ssn,
        profilePhoto: data.ReturnToAccount.UserFirmAccount.Users.UserInformation.profilePhoto,
        firmAccountId: data.ReturnToAccount.UserFirmAccount.FirmAccount.id,
        languageId: data.ReturnToAccount.UserFirmAccount.Users.languageId,
        userRole: data.ReturnToAccount.UserFirmAccount.Roles.description,
        // eslint-disable-next-line
        progressStatuses: data.ReturnToAccount.UserFirmAccount.FirmAccount.ProgressStatuses?.map(({ status, underlyingStatus, index, id }) => ({ status, underlyingStatus, index, id })) ?? undefined,
        firmName: '',
        firmAddress: '',
        firmPhoneNumber: '',
        firmCreatedAt: data.ReturnToAccount.UserFirmAccount.FirmAccount.createAt ?? '',
      }));
      navigate('/');
    }
  }, [data, navigate, dispatch]);

  const handleClick = async () => {
    try {
      await returnToAccount();
    } catch (e) {
      console.warn(e);
    }
    Message('returning to previous account...', 'success');
  };

  return (
    <ActionButton
      tooltip="Edit Options"
      onClick={handleClick}
    >
      Return to account
    </ActionButton>
  );
}

export default TestButton;
